<app-wrapper
    [title]="'PUBLIC_TIMELINE_SHARING.TITLE' | translate"
>
    <div class="body-wrapper d-flex flex-row">
        <p class="body16 color-gray">
            {{'PUBLIC_TIMELINE_SHARING.BODY' | translate}}
        </p>
    </div>
    <div class="d-flex justify-content-center align-items-center w-100">
        <canvas #qrCode class="qrcode" [ngClass]="{'invisible w-0 h-0': loadingQrCode()}">
        </canvas>
    </div>
    @if (loadingQrCode())
    {
        <div class="d-flex justify-content-center align-items-center w-100">
            <div class="spinner-container d-flex align-items-center justify-content-center">
                <mat-spinner />
            </div>
        </div>
    }
</app-wrapper>
